import React from 'react';
import ModalDialog from '../shared/modal/ModalDialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStopwatch } from '@fortawesome/pro-light-svg-icons';
import { SModalDescription } from '../shared/modal/ModalDialog.styled';

interface IProps {
  showTimeoutModal: boolean;
  doLogout: () => void;
  doContinue: () => void;
}

const TimeoutModal: React.FC<IProps> = ({ showTimeoutModal, doLogout, doContinue }) => {
  return (
    <ModalDialog
      id="modalSessionEndWarning"
      onClose={doLogout}
      showPrompt={showTimeoutModal}
      icon={<FontAwesomeIcon icon={faStopwatch} size="lg" />}
      title="Session Expiry"
      notHasCloseIcon={true}
      modalButtons={[
        {
          label: 'Refresh',
          action: doContinue,
          color: { color: 'secondary' },
          id: 'btnLogout',
        },
        {
          label: 'Logout',
          action: doLogout,
          color: { color: 'secondary' },
          id: 'btnLogout',
        },
      ]}
    >
      <SModalDescription>
        <p>Your session is set to expire soon!</p>
        <p className="important-description">Refresh your session?</p>
      </SModalDescription>
    </ModalDialog>
  );
};

export default TimeoutModal;
